import { GOAL_CATEGORY, GOAL_TYPE } from '../constants/goals';
export const GOAL_TYPE_CONFIG = {
  [GOAL_TYPE.FIRST_FORM_SUBMISSION]: {
    category: GOAL_CATEGORY.MARKETING
  },
  [GOAL_TYPE.NUMBER_OF_CONTACTS_IN_LIFECYCLE]: {
    category: GOAL_CATEGORY.MARKETING
  },
  [GOAL_TYPE.NUMBER_OF_NETWORK_CONVERSIONS]: {
    category: GOAL_CATEGORY.MARKETING
  },
  [GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE]: {
    category: GOAL_CATEGORY.MARKETING
  }
};